import { Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { ColorDescription } from 'app/components/ColorDescription';
import { translations } from 'locales/i18n';
import { Colors } from 'utils/colors';

export const AvailableColorsVacation = () => {
  const { t } = useTranslation();
  return (
    <Grid item>
      <ColorDescription
        color={Colors.vacationColor}
        colorDescription={t(
          translations.pages.leihbarOpeningHoursSettings.vacation.ColorDescription.vacation()
        )}
      />
      <ColorDescription
        color={Colors.vacationConflictBookingColor}
        colorDescription={t(
          t(translations.pages.leihbarOpeningHoursSettings.vacation.ColorDescription.booking())
        )}
      />
      <ColorDescription
        color={Colors.vacationAndBookingColor}
        colorDescription={t(
          t(
            translations.pages.leihbarOpeningHoursSettings.vacation.ColorDescription.vacationBooking()
          )
        )}
      />
    </Grid>
  );
};
